import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import PropTypes from 'prop-types'
import ChatDisplay from './ChatDisplay'

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ChatDetail(props) {

    const classes = useStyles();
    const { data, onClose, open } = props;

    return (
        <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
            <div data-id="headerChatDetail">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {data != null ? data.fullName : i18next.t("chat:tabPanelDetail.detailChat")}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </div>
            {data != null && <ChatDisplay data={data}/>}
        </Dialog>
    )
}

ChatDetail.propTypes = {
    data: PropTypes.object.isRequired
}